var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient } from "aurelia-dependency-injection";
import { autoinject, noView } from "aurelia-framework";
import "protip";
var TooltipCustomAttribute = /** @class */ (function () {
    function TooltipCustomAttribute(element) {
        var _this = this;
        this.element = element;
        this.setTooltip = function () {
            _this.protipTooltip = $(_this.element).protipSet();
            document.removeEventListener("aurelia-composed", _this.setTooltip, false);
        };
    }
    TooltipCustomAttribute_1 = TooltipCustomAttribute;
    TooltipCustomAttribute.prototype.bind = function () {
        if (!TooltipCustomAttribute_1.set) {
            $.protip({
                defaults: { trigger: "hover" }
            });
            TooltipCustomAttribute_1.set = true;
        }
        ;
        if (this.protipTooltip) {
            $["_protipClassInstance"].getItemInstance(this.protipTooltip).destroy();
        }
        var tooltipEl = document.getElementById('tooltip');
        if (!tooltipEl) {
            document.addEventListener("aurelia-composed", this.setTooltip, false);
        }
        else {
            this.setTooltip();
        }
    };
    TooltipCustomAttribute.prototype.unbind = function () {
        try {
            var prootipClassInstance = $["_protipClassInstance"];
            if (this.protipTooltip && prootipClassInstance) {
                var instance = prootipClassInstance.getItemInstance(this.protipTooltip);
                instance.destroy();
            }
        }
        catch (ex) { }
    };
    var TooltipCustomAttribute_1;
    TooltipCustomAttribute.set = false;
    TooltipCustomAttribute = TooltipCustomAttribute_1 = __decorate([
        noView(),
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [Element])
    ], TooltipCustomAttribute);
    return TooltipCustomAttribute;
}());
export { TooltipCustomAttribute };
